import { delay } from "common/promises/delay";
export async function createPromise() {
    return await new Promise((outerResolve) => {
        const wrapper = {
            toRet: null,
        };
        wrapper.toRet = new Promise(async (resolve, reject) => {
            await delay(1);
            outerResolve({ promise: wrapper.toRet, resolve, reject });
        });
    });
}
//# sourceMappingURL=create.js.map